import type { StepName } from '@website/hooks/useBookingSteps';

export type BookingUrlBookingType = 'SINGLE' | 'GROUP' | 'RANGE';
export type BookingUrlPaymentMethod = 'cash' | 'online';
export type BookingUrlLocationKind = 'venue' | 'at_home' | 'online';

/**
 * The booking flow's state in the URL of the activity's slot picker: what `useBookingUrlState`
 * reads and {@link bookingFlowHref} writes, so a link into the flow and the flow agree on its keys.
 */
export type BookingUrlParams = {
  step: StepName;
  slotId: string;
  date: string;
  startTime: number;
  endTime: number;
  locationId: string;
  locationKind: BookingUrlLocationKind;
  addressId: string;
  bookingType: BookingUrlBookingType;
  numberOfPeople: number;
  paymentMethod: BookingUrlPaymentMethod;
  /** 1 when cash is closed for this client on the slot (first session with the pro is paid online). */
  firstBookingOnlineRequired: 1;
};

export type BookingUrlParam = keyof BookingUrlParams;

/** A link into the activity's booking flow with some of its state already chosen. */
export function bookingFlowHref(activityId: string, params: Partial<BookingUrlParams>, locale: string): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) query.set(key, String(value));
  }
  const search = query.toString();
  return `/${locale}/activity/${activityId}/slots${search ? `?${search}` : ''}`;
}
